export default {
	0: "InAnalysis",
	1: "Approved",
	2: "Rejected"
};
